import { useEffect, useState } from 'react'
import ReactHowler from 'react-howler'
import { NavLink } from 'react-router-dom'
import ReactGA from 'react-ga4'
export const Navigation = () => {
    const [navbarOpen, setNavbarOpen] = useState(false)
    const [soundOn, setSoundOn] = useState(false)
    const [soundState, setSoundState] = useState(0) // 0: Off, 1: Low Volume, 2: High Volume
    const handleSoundToggle = () => {
        setSoundState((prevState) => (prevState + 1) % 3)
    }
    const scrollToTop = () => {
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        })
    }
    // const [soundState, setSoundState] = useState(0) // 0: Off, 1: Low Volume, 2: High Volume
    // const handleSoundToggle = () => {
    //     setSoundState((prevState) => (prevState + 1) % 3)
    // }
    let imageUrl
    switch (soundState) {
        case 0:
            imageUrl = `${process.env.PUBLIC_URL}/images/bgm-off.png`
            break
        case 1:
            imageUrl = `${process.env.PUBLIC_URL}/images/bgm-low.png`
            break
        case 2:
            imageUrl = `${process.env.PUBLIC_URL}/images/bgm-on.png`
            break
        default:
            imageUrl = `${process.env.PUBLIC_URL}/images/bgm-off.png`
    }
    const isPlaying = soundState !== 0
    const volume = soundState === 1 ? 0.1 : 0.6
    return (
        <header className='md:block items-center sticky top-0 z-50 bg-white/20 md:backdrop-blur-sm md:px-4'>
            <div className='mx-auto hidden md:block relative'>
                <div className='relative'>
                    <ul className='px-0 flex max-w-[1200px] mx-auto flex-row  justify-between cursor-pointer items-center h-[80px] '>
                        <li>
                            <NavLink to='/' end className={({ isActive }) => (isActive ? 'active' : 'inactive')}>
                                <span className='relative  newicon-nav  inline-block'>
                                    {' '}
                                    <h1 className='text-center text-gradient-nav text-sm md:text-navsmall lg:text-nav font-pop'>
                                        Top
                                    </h1>
                                </span>
                            </NavLink>{' '}
                        </li>
                        <li>
                            <NavLink to='story' className={({ isActive }) => (isActive ? 'active' : 'inactive')}>
                                <h1 className='text-center text-gradient-nav text-sm md:text-navsmall lg:text-nav font-pop'>
                                    Histoire
                                </h1>{' '}
                            </NavLink>
                        </li>{' '}
                        <li>
                            <span className='relative inline-block'>
                                <NavLink
                                    to='characters'
                                    className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                                >
                                    <h1 className='text-center text-gradient-nav text-sm md:text-navsmall lg:text-nav font-pop'>
                                        Personnages
                                    </h1>{' '}
                                </NavLink>{' '}
                            </span>
                        </li>{' '}
                        <li>
                            <span className='relative inline-block'>
                                <NavLink to='system' className={({ isActive }) => (isActive ? 'active' : 'inactive')}>
                                    <h1 className='text-center text-gradient-nav text-sm md:text-navsmall lg:text-nav font-pop'>
                                        Système
                                    </h1>{' '}
                                </NavLink>{' '}
                            </span>
                        </li>
                        <li>
                            <NavLink to='media' className={({ isActive }) => (isActive ? 'active' : 'inactive')}>
                                <span className='relative  newicon-nav  inline-block'>
                                    {' '}
                                    <h1 className='text-center text-gradient-nav text-sm md:text-navsmall lg:text-nav font-pop'>
                                        Media
                                    </h1>
                                </span>
                            </NavLink>{' '}
                        </li>{' '}
                        <li>
                            {' '}
                            <span className='relative newicon-nav inline-block'>
                                <NavLink to='dlc' className={({ isActive }) => (isActive ? 'active' : 'inactive')}>
                                    <h1 className='text-center text-gradient-nav text-sm md:text-navsmall lg:text-nav font-pop'>
                                        DLC
                                    </h1>{' '}
                                </NavLink>{' '}
                            </span>
                        </li>
                        <li>
                            {' '}
                            <span className='relative inline-block'>
                                <NavLink to='products' className={({ isActive }) => (isActive ? 'active' : 'inactive')}>
                                    <h1 className='text-center text-gradient-nav text-sm md:text-navsmall lg:text-nav font-pop'>
                                        Produits Dérivés
                                    </h1>{' '}
                                </NavLink>{' '}
                            </span>
                        </li>{' '}
                        <li>
                            {' '}
                            <span className='relative inline-block'>
                                <a
                                    href='https://nisamerica.com/phantombrave-the-lost-hero-fr/manual'
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    <h1 className='text-center text-gradient-nav text-sm md:text-navsmall lg:text-nav font-pop'>
                                        Manuel
                                    </h1>{' '}
                                </a>{' '}
                            </span>
                        </li>
                        <button onClick={handleSoundToggle}>
                            <img className='' src={imageUrl} alt='bgm on off button' />
                            <ReactHowler
                                src={`${process.env.PUBLIC_URL}/voice/016_south_island.mp3`}
                                playing={isPlaying}
                                loop={true}
                                volume={volume}
                                onEnd={() => setSoundState(0)}
                            />{' '}
                        </button>
                    </ul>
                </div>
            </div>
            {/* mobile navbar */}

            <div className='md:hidden'>
                <div className='fixed top-1 right-1 z-10'>
                    <img
                        className='w-auto max-w-[65px]'
                        src={`${process.env.PUBLIC_URL}/images/bg_close.png`}
                        alt='close'
                    />{' '}
                    <div className='absolute top-1/2 -translate-y-1/2 left-1/2 -translate-x-1/2 z-10 p-1'>
                        <button onClick={() => setNavbarOpen(!navbarOpen)} className=''>
                            <img
                                className='w-full hover:brightness-150'
                                src={`${process.env.PUBLIC_URL}/images/btn_open.png`}
                                alt='open'
                            />{' '}
                        </button>{' '}
                        <button onClick={handleSoundToggle}>
                            <img className='' src={imageUrl} alt='bgm on off button' />
                            <ReactHowler
                                src={`${process.env.PUBLIC_URL}/voice/016_south_island.mp3`}
                                playing={isPlaying}
                                loop={true}
                                volume={volume}
                                onEnd={() => setSoundState(0)}
                            />{' '}
                        </button>{' '}
                        <div className='md:hidden block translate-y-[20px]'>
                            <div className='left-1/2 -translate-x-1/2 absolute flex flex-col md:flex-row  items-center  bg-pbyellow border-pbnavy border-3  text-pbnavy font-sans text-subsmall rounded-lg'>
                                <div className='bg-pbnavy text-pbyellow w-full'>
                                    <p className='m-1 text-center'>Textes</p>
                                </div>
                                <div className='relative w-full '>
                                    <div className='w-full text-pborange py-1 px-1 text-center'>
                                        <p>Français</p>{' '}
                                    </div>
                                </div>
                                <div className='w-full text-pbnavy hover:text-pborange py-1 px-1 text-center'>
                                    <a href='https://nisamerica.com/phantombrave-the-lost-hero'>English</a>{' '}
                                </div>
                            </div>{' '}
                        </div>
                    </div>
                </div>

                <div
                    onClick={() => setNavbarOpen(!navbarOpen)}
                    className={`ease-in-out duration-500 py-20 top-0 left-0 w-full fixed z-20 lg:hidden  ${
                        navbarOpen
                            ? 'absolute translate-x-0 bg-white/20 backdrop-blur-md h-screen '
                            : '-translate-y-[800px]'
                    }`}
                >
                    <div className='absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 global-menu'>
                        <button onClick={() => setNavbarOpen(!navbarOpen)} className=''>
                            <img
                                className='global-nav-close-button'
                                src={`${process.env.PUBLIC_URL}/images/btn_close.png`}
                                alt='close'
                            />{' '}
                        </button>{' '}
                        <ul className='flex flex-col space-y-1 text-center'>
                            <li>
                                <NavLink
                                    onClick={() => {
                                        setNavbarOpen(!navbarOpen)
                                        scrollToTop()
                                    }}
                                    to='/'
                                    end
                                    className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                                >
                                    <span className='relative inline-block newicon-nav'>
                                        <h1 className='text-center text-gradient-nav text-md inline-block lg:text-xlg font-pop'>
                                            Top
                                        </h1>{' '}
                                    </span>
                                </NavLink>{' '}
                            </li>
                            <li>
                                <NavLink
                                    onClick={() => {
                                        setNavbarOpen(!navbarOpen)
                                        scrollToTop()
                                    }}
                                    to='story'
                                    className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                                >
                                    <h1 className='text-center text-gradient-nav text-md lg:text-xlg font-pop'>
                                        Histoire
                                    </h1>{' '}
                                </NavLink>
                            </li>{' '}
                            <li className='w-full text-center'>
                                {' '}
                                <NavLink
                                    onClick={() => {
                                        setNavbarOpen(!navbarOpen)
                                        scrollToTop()
                                    }}
                                    to='characters'
                                    className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                                >
                                    {' '}
                                    <span className='relative'>
                                        <h1 className='text-center text-gradient-nav text-md inline-block lg:text-xlg font-pop'>
                                            Personnages
                                        </h1>{' '}
                                    </span>
                                </NavLink>
                            </li>{' '}
                            <li className='w-full text-center'>
                                {' '}
                                <NavLink
                                    onClick={() => {
                                        setNavbarOpen(!navbarOpen)
                                        scrollToTop()
                                    }}
                                    to='system'
                                    className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                                >
                                    {' '}
                                    <span className='relative'>
                                        <h1 className='text-center text-gradient-nav text-md inline-block lg:text-xlg font-pop'>
                                            Systéme
                                        </h1>{' '}
                                    </span>
                                </NavLink>
                            </li>
                            <li className='w-full text-center'>
                                <NavLink
                                    onClick={() => {
                                        setNavbarOpen(!navbarOpen)
                                        scrollToTop()
                                    }}
                                    to='media'
                                    className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                                >
                                    {' '}
                                    <span className='relative inline-block newicon-nav'>
                                        <h1 className='text-center text-gradient-nav text-md inline-block lg:text-xlg font-pop'>
                                            Media
                                        </h1>{' '}
                                    </span>
                                </NavLink>
                            </li>{' '}
                            <li className='w-full text-center'>
                                <NavLink
                                    onClick={() => {
                                        setNavbarOpen(!navbarOpen)
                                        scrollToTop()
                                    }}
                                    to='dlc'
                                    className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                                >
                                    {' '}
                                    <span className='relative inline-block newicon-nav'>
                                        <h1 className='text-center text-gradient-nav text-md inline-block lg:text-xlg font-pop'>
                                            DLC
                                        </h1>
                                    </span>
                                </NavLink>
                            </li>
                            <li className='w-full text-center'>
                                <NavLink
                                    onClick={() => {
                                        setNavbarOpen(!navbarOpen)
                                        scrollToTop()
                                    }}
                                    to='products'
                                    className={({ isActive }) => (isActive ? 'active' : 'inactive')}
                                >
                                    {' '}
                                    <span className='relative '>
                                        <h1 className='text-gradient-nav text-md lg:text-xlg font-pop inline-block text-center'>
                                            Produits Dérivés
                                        </h1>{' '}
                                    </span>
                                </NavLink>
                            </li>{' '}
                            <li className='w-full text-center'>
                                <a
                                    href='https://nisamerica.com/phantombrave-the-lost-hero-fr/manual'
                                    target='_blank'
                                    rel='noreferrer'
                                >
                                    {' '}
                                    <span className='relative'>
                                        <h1 className='text-gradient-nav text-md lg:text-xlg font-pop inline-block text-center'>
                                            Manuel
                                        </h1>{' '}
                                    </span>
                                </a>
                            </li>{' '}
                        </ul>{' '}
                    </div>{' '}
                </div>
            </div>
        </header>
    )
}
